import tagTester from './_tagTester.js';

export default tagTester('String');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isString.js
// module id = 121
// module chunks = 0 1